import api from './api';

const supportTicketService = {
  // Create support ticket
  createTicket: (data) => {
    return api.post('/support-tickets', data);
  },

  // Get all tickets (for super admin)
  getAllTickets: (params = {}) => {
    return api.get('/support-tickets', { params });
  },

  // Get my tickets
  getMyTickets: (params = {}) => {
    return api.get('/support-tickets/my-tickets', { params });
  },

  // Update ticket status
  updateTicketStatus: (ticketId, status) => {
    return api.put(`/support-tickets/${ticketId}/status`, { status });
  }
};

export default supportTicketService;
